import { __exports as MSI11 } from "./index204.js";
import { __require as requireMSI } from "./index175.js";
import { __require as requireChecksums } from "./index203.js";
var hasRequiredMSI11;
function requireMSI11() {
  if (hasRequiredMSI11) return MSI11;
  hasRequiredMSI11 = 1;
  Object.defineProperty(MSI11, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI11$1 = (function(_MSI) {
    _inherits(MSI112, _MSI);
    function MSI112(data, options) {
      _classCallCheck(this, MSI112);
      return _possibleConstructorReturn(this, (MSI112.__proto__ || Object.getPrototypeOf(MSI112)).call(this, data + (0, _checksums.mod11)(data), options));
    }
    return MSI112;
  })(_MSI3.default);
  MSI11.default = MSI11$1;
  return MSI11;
}
export {
  requireMSI11 as __require
};
//# sourceMappingURL=index177.js.map
